import { useContext } from "react";
import React from 'react';
import { createUpdatableContext } from "./UpdatableContext";

export var ProfileContext = createUpdatableContext();
export var WindowSettingsContext = createUpdatableContext();

export function useProfile() {
    let profileContext = useContext(ProfileContext);
    return [profileContext.value, profileContext.updateFunction];
};

export function useWindowSettings() {
	let displaySettings = useContext(WindowSettingsContext);
	return [displaySettings.value, displaySettings.updateFunction];
}